import TYPES from 'Catalog/types';

// ========================= Category ============================ //

export const openFilterCategory = ({ itemId }) => ({
  type: TYPES.OPEN_FILTER_CATEGORY,
  payload: { itemId },
});

export const toggleFilterCategory = ({ itemId, subItemId }) => ({
  type: TYPES.TOGGLE_FILTER_CATEGORY,
  payload: { itemId, subItemId },
});

// ========================= Category ============================ //

export const toggleFilterCourses = ({ subCourseId }) => ({
  type: TYPES.TOGGLE_FILTER_COURSES,
  payload: { subCourseId },
});

export const openFilterCourses = () => ({
  type: TYPES.OPEN_FILTER_COURSE,
});

// ========================= Software ============================ //

export const toggleFilterSoftware = ({ subItemId }) => ({
  type: TYPES.TOGGLE_FILTER_SOFTWARE,
  payload: { subItemId },
});

export const openFilterSoftware = () => ({
  type: TYPES.OPEN_FILTER_SOFTWARE,
});

// ========================= Level ============================ //

export const toggleFilterLevel = ({ subItemId }) => ({
  type: TYPES.TOGGLE_FILTER_LEVEL,
  payload: { subItemId },
});

export const openFilterLevel = () => ({
  type: TYPES.OPEN_FILTER_LEVEL,
});

/** ***** Languages ******** */

export const toggleFilterLanguage = ({ subItemId }) => ({
  type: TYPES.TOGGLE_FILTER_LANGUAGE,
  payload: { subItemId },
});

export const setSelectedLanguages = payload => ({
  type: TYPES.SET_SELECTED_LANGUAGES,
  payload,
});

export const openFilterLanguage = () => ({
  type: TYPES.OPEN_FILTER_LANGUAGE,
});

// common
export const showAllCourses = () => ({
  type: TYPES.SHOW_ALL_COURSES,
});

export const clearAllFilters = () => ({
  type: TYPES.CLEAR_ALL_FILTERS,
});

export const clearSoftwareFilters = () => ({
  type: TYPES.CLEAR_SOFTWARE_FILTERS,
});

export const clearLevelFilters = () => ({
  type: TYPES.CLEAR_LEVELS_FILTERS,
});

export const disableSoftwaresAndLevels = ({ softwares, levels }) => ({
  type: TYPES.DISABLE_FILTERS_SOFTWARE_LEVELS,
  payload: { softwares, levels },
});

export const toggleFilterDialog = () => ({
  type: TYPES.TOGGLE_FILTER_DIALOG,
});
